import { render } from "./bidangEkraf.vue?vue&type=template&id=046da15b"
import script from "./bidangEkraf.vue?vue&type=script&lang=js"
export * from "./bidangEkraf.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__